import { EventBus } from './globalEventBus';
import soundPlayer from './soundPlayer';

const captionPlayerBus = new EventBus();

// Bridge soundPlayer callbacks → bus events (for all existing listeners)
soundPlayer.onPlayEnd(() => {
    captionPlayerBus.emit('onPlayEnd');
});
soundPlayer.onPlayStop(() => {
    captionPlayerBus.emit('onPlayStop');
});

captionPlayerBus.on('playSound', url => {
    soundPlayer.playSound(url);
});
captionPlayerBus.on('stopSound', () => {
    soundPlayer.stopPlay();
});
captionPlayerBus.on('playText', text => {
    soundPlayer.playText(text);
});

export default captionPlayerBus;
